export default ({ isAllowed = false, key = '' }) => {
    return { isAllowed, key };
};
